import { PureComponent, createRef } from "react";

export interface IFilterProps {
  onFilterChange: (value: any) => void;
  placeholder: string;
}

export default class Filter extends PureComponent<IFilterProps> {
  private inputRef = createRef<HTMLInputElement>();

  constructor(props: IFilterProps) {
    super(props);
  }

  public static defaultProps = {
    placeholder: "Filter...",
  };

  public getRef = () => {
    return this.inputRef;
  };

  public clear = () => {
    if (this.inputRef && this.inputRef.current) {
      this.inputRef.current.value = "";
    }
  };

  render() {
    return (
      <div className="picky__filter">
        <input
          type="text"
          ref={this.inputRef}
          className="picky__filter__input"
          placeholder={this.props.placeholder}
          onChange={(e) => this.props.onFilterChange(e.target.value)}
        />
      </div>
    );
  }
}
